import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import '../styles/Navbar.css';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const checkMobileView = () => {
            setIsMobileView(window.innerWidth <= 768);
        };

        checkMobileView();

        window.addEventListener('resize', checkMobileView);

        return () => window.removeEventListener('resize', checkMobileView);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="navbar">
            <div className="logo">
                <a href="/">SAGARA</a>
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
            <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
                <li>
                    <ScrollLink
                        to="hero"
                        smooth={true}
                        duration={500}
                        onClick={toggleMenu}
                    >
                        Beranda
                    </ScrollLink>
                </li>
                <li>
                    <ScrollLink
                        to="panduan"
                        smooth={true}
                        duration={500}
                        onClick={toggleMenu}
                    >
                        Panduan
                    </ScrollLink>
                </li>
                <li>
                    <ScrollLink
                        to="mekanisme"
                        smooth={true}
                        duration={500}
                        onClick={toggleMenu}
                    >
                        Mekanisme
                    </ScrollLink>
                </li>
                <li>
                    <ScrollLink
                        to="artikel"
                        smooth={true}
                        duration={500}
                        onClick={toggleMenu}
                    >
                        Artikel
                    </ScrollLink>
                </li>
                <li>
                    <ScrollLink
                        to="faq"
                        smooth={true}
                        duration={500}
                        onClick={toggleMenu}
                    >
                        FAQ
                    </ScrollLink>
                </li>
                {isMobileView && (
                    <li>
                        <a
                            href="/laporan"
                            className="btn-laporan"
                            onClick={toggleMenu}
                        >
                            BUAT LAPORAN
                        </a>
                    </li>
                )}
            </ul>
            {!isMobileView && (
                <a href="/laporan" className="btn-laporan">
                    BUAT LAPORAN
                </a>
            )}
        </nav>
    );
};

export default Navbar;